<div [formGroup]="parentForm">
    <ng-container *ngTemplateOutlet="innerTree; context: { children: tree.children }"></ng-container>
</div>

<ng-template #innerTree let-children="children">
    <ul class="internal-tree">
        @for (node of children; track node) {
            <li>
                <ng-container *ngTemplateOutlet="valueContainer; context: { $implicit: node }"></ng-container>
                @if (node.hasChildren && node.isExpanded) {
                    <ng-container *ngTemplateOutlet="innerTree; context: { children: node.children }"></ng-container>
                }
            </li>
        }
    </ul>
</ng-template>

<ng-template #valueContainer let-node>
    <div class="value-container" [ngClass]="{ leaf: !node.hasChildren }" (click)="clickNode(node)">
        @if (node.hasChildren) {
            <span class="caret" [ngClass]="{ 'caret-down': node.isExpanded }"></span>
        }
        @if (!node.hasChildren) {
            <div class="checkbox-container">
                @if (node.selected) {
                    <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                }
            </div>
        }
        @if (node.hasChildren) {
            <div class="checkbox-container has-children">
                @if (node.selectedChildren.length > 0) {
                    <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                }
            </div>
        }

        <label>{{ node.value }}</label>
        @if (node.selected) {
            <div>
                <button class="btn pace-link" (click)="collapseAll()">Collapse</button>
            </div>
        }
    </div>
</ng-template>
